import "@knowtex-ai/components/style.css";
import "./foia.css";
import { ToastProvider } from "@knowtex-ai/components";
import Sidebar from "../Sidebar";
import { Toaster } from "../ui/Toaster";

export default function FoiaPageShell({ setAuth, setUserOrg, children }) {
  return (
    <ToastProvider>
      <div className="foia-page flex min-h-screen bg-[#fafafa]">
        <Sidebar setAuth={setAuth} setUserOrg={setUserOrg} />
        <div className="flex-1 min-w-0" style={{ marginLeft: "var(--sidebar-width, 250px)" }}>
          <div className="max-w-[1180px] mx-auto px-6 py-8 md:px-10">{children}</div>
        </div>
      </div>
      <Toaster />
    </ToastProvider>
  );
}
